import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "./Checkbox";
import { useController } from "react-hook-form";
import { useTranslationApp } from "../../lib/i18next";
import { getReactHookFormNestedError } from "../../utils/errors";

const CheckBoxes = ({
  control,
  errors,
  rules,
  name,
  disabled,
  label,
  options = [],
}) => {
  const error = getReactHookFormNestedError(errors, name);
  const { t } = useTranslationApp();

  const {
    field: { onChange, value },
  } = useController({
    control,
    name,
    rules,
  });
  return (
    <FormControl
      component="fieldset"
      variant="filled"
      disabled={disabled}
      error={!!error}
    >
      <FormLabel component="legend">{t(label)}</FormLabel>
      <Box
        sx={{
          mt: 1,
          display: "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          gap: 2,
          width: "100%",
        }}
      >
        {options.map((option) => {
          const inputId = `${name}-${String(option.key)}`;
          return (
            <Box
              key={option.key}
              sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 0,
                maxWidth: "100%",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                  minWidth: 0,
                  maxWidth: "100%",
                }}
              >
                <Box
                  sx={{
                    flexShrink: 0,
                    alignSelf: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    lineHeight: 0,
                  }}
                >
                  <Checkbox
                    disabled={disabled || option.disabled}
                    checked={value?.[option.key]}
                    onChange={(e) => {
                      if (disabled || option.disabled) {
                        return;
                      }
                      onChange({
                        ...value,
                        [option.key]: e.target.checked,
                      });
                    }}
                    name={option.key}
                    inputProps={{ id: inputId }}
                  />
                </Box>
                <Box
                  component="label"
                  htmlFor={inputId}
                  sx={{
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: 0,
                    alignSelf: "center",
                    minWidth: 0,
                    maxWidth: "100%",
                    overflowWrap: "break-word",
                    cursor: option.disabled || disabled ? "default" : "pointer",
                  }}
                >
                  <Typography component="span" variant="body1" display="block">
                    {t(option.label)}
                  </Typography>
                  {option.subLabel && (
                    <Typography
                      variant="body2"
                      display="block"
                      sx={{
                        fontStyle: "italic",
                        color: "GrayText",
                        mt: 0.25,
                      }}
                    >
                      {t(option.subLabel)}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
      {!!error && (
        <Typography variant="caption" color="error">
          {error?.message}
        </Typography>
      )}
    </FormControl>
  );
};

export default CheckBoxes;
